"use strict";
exports.__esModule = true;
exports.toUint8Array = void 0;
function toUint8Array(str) {
    return new Uint8Array(str.split('').map(function (c) { return c.charCodeAt(0); }));
}
exports.toUint8Array = toUint8Array;
